import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationTypeForm from './ApplicationTypeForm';

const ApplicationTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationTypeEdit = (props: any) => {
  return (
    <Edit actions={<ApplicationTypeActions {...props} />} {...props}>
      <ApplicationTypeForm />
    </Edit>
  );
};

export default ApplicationTypeEdit;
